import { CommApiInstance } from "Utils/CommApiInstance";

const GameMainPageApi = async (
    gameSvcCd:string,
    
) => {
    return await CommApiInstance.post(`${gameSvcCd}/main_page`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default GameMainPageApi;